import EChartsReact from 'echarts-for-react'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { Image } from 'react-bootstrap-icons'

export default observer(function PostEngagements({ currentAuthentication }) {

  const posts = useMemo(() => currentAuthentication.posts, [currentAuthentication.posts, currentAuthentication.posts.length])

  const engagementRates = useMemo(() => {
    return posts.reduce((result, post) => {
      const engagement_rate = (post.likes_count + post.comments_count) / currentAuthentication.reach * 100
      if(engagement_rate < 1.5) result[0] += 1
      else if(engagement_rate < 2.5) result[1] += 1
      else if(engagement_rate < 3.5) result[2] += 1
      else if(engagement_rate < 4.5) result[3] += 1
      else if(engagement_rate < 6) result[4] += 1
      else if(engagement_rate < 8) result[5] += 1
      else if(engagement_rate < 10) result[6] += 1
      else result[7] += 1
      return result
    }, [0, 0, 0, 0, 0, 0, 0, 0])
  }, [posts, posts.length])

  const option = useMemo(() => ({
    xAxis: {
      data: ['0-1.5%', '1.5-2.5%', '2.5-3.5%', '3.5-4.5%', '4.5-6%', '6-8%', '8-10%', '10+%'],
      axisLabel: {
        interval: 0,
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
    },
    yAxis: {
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    series: [
      {
        type: 'bar',
        data: engagementRates,
        itemStyle: {
          barBorderRadius: [10, 10, 0, 0],
          borderWidth: 1,
          borderType: 'solid',
          borderColor: '#2CCDB4',
          color: '#2CCDB4'
        },
      }
    ],
    tooltip: {
      trigger: 'item',
    },
    textStyle: {
      fontSize: 14
    }
  }), [currentAuthentication.audience_information])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-4">
      <div className="flex justify-between p-8 border-b-1 border-gray-300 dark:border-rb-dark-mode-lighter">
        <div className="flex items-center">
          <div className="mr-2 dark:text-white"><Image /></div>
          <p className="font-bold text-xl dark:text-white">Engagement rate of posts</p>
        </div>
        <p className="font-bold dark:text-white">total: {posts.length}</p>
      </div>
      <EChartsReact option={option} style={{ width: '100%', height: '300px' }} />

    </div>
  )
})